/** @flow */
import { resourceReducer } from 'redux-resource'
import { paginatedList } from 'app/libs/redux-resource-plugins/paginated-list'
import includedResources from 'app/libs/redux-resource-plugins/includedResources'
import * as resources from '../resources/resources'

import user from './user.ts'
import project from './project'
import assetTalks from './assetTalks'
import notifsCount from './notifsCount'
import organizationChart from './organizationChart.ts'
import calculatedFields from './calculatedFields.ts'
import projectConfig from './config.ts'
import library from './library.ts'
import externalJobs from './externalJobs.ts'
import lockedFilters from './lockedFilters.ts'
import collectiveAgreementTitles from './collectiveAgreementTitles.ts'
import leaves from './leaves.ts'
import allUsersWithActivities from './usersWithActivities.ts'
import tablesPrefs from './tablesPrefs.ts'
import activitiesApprovals from './activitiesApprovals.ts'
import reduxActivities from './reduxActivities.ts'
import taskTypes from './taskTypes.ts'
import projects from './projects.ts'
import departmentsRedux from './departments.ts'
import departmentJobs from './departmentJobs.ts'
import messages from './messages.ts'
import reduxTasks from './tasks.ts'
import reduxTakes from './takes.ts'
import reduxTakesFlags from './takesFlags.ts'
import reduxAssets from './assets.ts'
import tablesFilters from './tablesFilters.ts'
import router from './router.ts'
import reduxPostBoardNotes from './reduxPostBoardNotes.ts'
import reduxPostBoardLinks from './reduxPostboardLinks.ts'
import reduxAssetLinks from './reduxAssetLinks.ts'
import reduxDynamicApprovalValues from './reduxDynamicApprovalValues.ts'
import reduxFlags from './reduxFlags.ts'
import reduxAssetFlags from './reduxAssetFlags.ts'
import reduxMedias from './reduxMedias.ts'
import reduxTakeValidationMedias from './reduxTakeValidationMedias.ts'
import reduxTakeRefMedias from './reduxTakeRefMedias.ts'
import tableFollowUpPrefs from './tableFollowUpPrefs.ts'
import statsStatus from './stats.ts'
import stateKey from './stateKey.ts'
import dashboards from './dashboards.ts'
import widgets from './widgets.ts'
import dashboardWidgets from './dashboardWidgets.ts'
import reduxSteps from './steps.ts'
import reduxGroups from './groups.ts'
import reduxNotifications from './notifications.ts'
import reduxPosts from './reduxPosts.ts'
import offices from './offices.ts'

const reducersFromResources = {}

Object.entries(resources).forEach(([key, value]) => {
  reducersFromResources[key] = resourceReducer(key, {
    plugins: [includedResources, paginatedList],
    initialState: {
      paginatedLists: {},
    },
  })
})

export default {
  user,
  project,
  assetTalks,
  notifsCount,
  organizationChart,
  calculatedFields,
  projectConfig,
  library,
  externalJobs,
  lockedFilters,
  collectiveAgreementTitles,
  leaves,
  allUsersWithActivities,
  tablesPrefs,
  activitiesApprovals,
  reduxActivities,
  taskTypes,
  projects,
  departmentsRedux,
  departmentJobs,
  messages,
  reduxTasks,
  reduxTakes,
  reduxTakesFlags,
  reduxAssets,
  tablesFilters,
  router,
  reduxPostBoardNotes,
  reduxPostBoardLinks,
  reduxAssetLinks,
  reduxDynamicApprovalValues,
  reduxFlags,
  reduxAssetFlags,
  reduxMedias,
  reduxTakeValidationMedias,
  reduxTakeRefMedias,
  tableFollowUpPrefs,
  statsStatus,
  stateKey,
  dashboards,
  widgets,
  dashboardWidgets,
  reduxSteps,
  reduxGroups,
  reduxNotifications,
  reduxPosts,
  offices,
  ...reducersFromResources,
}
